export const CAMPAIGN_MANAGER_VER = Number(process.env.REACT_APP_CAMPAIGN_MANAGER_VER);
export const INVENTORY_MANAGER_VER = Number(process.env.REACT_APP_INVENTORY_MANAGER_VER);
